import { buildScopedI18n } from '../../utils/buildScopedI18n';
import loginEsCL from './locales/es-CL.json';
import loginEnUS from './locales/en-US.json';
import loginPtBR from './locales/pt-BR.json';

export const loginI18n = buildScopedI18n({
  esCL: loginEsCL,
  enUS: loginEnUS,
  ptBR: loginPtBR,
});
